<template>
  <DialogContainer :isOpen="isOpen" :onClose="closeModal" :hasCloseBtn="true">
    <template v-slot:title>Your Auto-Recharge Is Linked to This Card</template>

    <template v-slot:content>
      <div class="mt-4">
        <p class="text-sm text-gray-600">
          This card is used for automatic credit top-ups. 
          Would you like to transfer it to another card, or cancel the auto-recharge?
        </p>
        <div class="mt-6">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Transfer auto-recharge to:
          </label>
          <select v-model="selectedCardId" class="form-field-no-icon sm:w-full">
            <option v-for="card in otherCards" :key="card.id" :value="card.id">
              Card ending in {{ card.card.last4 }} 
            </option>
          </select>
        </div>
      </div>
    </template>

    <template v-slot:buttons>
      <div class="w-full flex items-center justify-between">
        <button
          type="button"
          class="button-cancel"
          @click="onCancelRecurring"
          :disabled="loading"
        >
          Cancel Auto-Recharge
        </button>
        <button
          type="button"
          class="button-submit"
          @click="onTransfer"
          :disabled="!selectedCardId || loading"
        >
          Transfer Auto-Recharge
        </button>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import { ref } from "vue";
import DialogContainer from "@/components/common/DialogContainer";
import eventBus from "@/utils/eventBus";

export default {
  name: "TransferRecurringModal",
  components: { DialogContainer },
  setup() {
    return {
      isOpen: ref(false),
      loading: ref(false),
      selectedCardId: ref(null),
      cardBeingDeleted: ref(null),
      otherCards: ref([]),
    };
  },
  methods: {
    openModal({ cardBeingDeleted, otherCards }) {
      this.cardBeingDeleted = cardBeingDeleted;
      this.otherCards = otherCards;
      this.selectedCardId = otherCards[0]?.id || null; // pre-select first available card
      this.loading = false;
      this.isOpen = true;
    },
    closeModal() {
      this.isOpen = false;
      this.loading = false;
    },
    async onTransfer() {
      if (!this.selectedCardId || this.loading) return;
      this.loading = true;
      try {
        // Step 1: Point the recurring setting at the new card
        await this.$alfredService.RecurringPaymentEdit({
          payment_method_id: this.selectedCardId,
        });
        // Step 2: Now delete the old card
        await this.$alfredService.deletePaymentMethod(this.cardBeingDeleted);
        eventBus.trigger("notify", {
          notification: {
            group: "top-right",
            type: "success",
            text: "Card deleted and auto-recharge transferred successfully.",
          },
        });
        eventBus.trigger("update-cards", {});
        this.closeModal();
      } catch {
        eventBus.trigger("notify", {
          notification: {
            group: "top-right",
            type: "error",
            text: "Something went wrong. Please try again.",
          },
        });
        this.loading = false;
      }
    },
    async onCancelRecurring() {
      if (this.loading) return;
      this.loading = true;
      try {
        // Just delete the card — the backend will clean up the recurring setting
        await this.$alfredService.deletePaymentMethod(this.cardBeingDeleted);
        eventBus.trigger("notify", {
          notification: {
            group: "top-right",
            type: "success",
            text: "Card deleted and auto-recharge cancelled.",
          },
        });
        eventBus.trigger("update-cards", {});
        this.closeModal();
      } catch {
        eventBus.trigger("notify", {
          notification: {
            group: "top-right",
            type: "error",
            text: "Something went wrong. Please try again.",
          },
        });
        this.loading = false;
      }
    },
  },
};
</script>
